import Managers from '../svgs/managers.svg';
import Admins from '../svgs/admins.svg';

export const possibilities = [
  {
    title: 'control.manage.title',
    description: 'control.manage.description',
    img: Managers
  },
  {
    title: 'control.admin.title',
    description: 'control.admin.description',
    img: Admins
  }
];

export const apps = [
  {
    img: '/services/devops_service/node.webp',
    width: 106,
    height: 65
  },
  {
    img: '/services/devops_service/python.webp',
    width: 159,
    height: 41
  },
  {
    img: '/services/devops_service/ruby.webp',
    width: 133,
    height: 48
  },
  {
    img: '/services/devops_service/php.webp',
    width: 109,
    height: 56
  },
  {
    img: '/services/devops_service/perl.webp',
    width: 140,
    height: 43
  },
  {
    img: '/services/devops_service/netcore.webp',
    width: 65,
    height: 65
  },
  {
    img: '/services/devops_service/rails.webp',
    width: 135,
    height: 52
  },
  {
    img: '/services/devops_service/django.webp',
    width: 115,
    height: 52
  },
  {
    img: '/services/devops_service/phpcake.webp',
    width: 112,
    height: 58
  },
  {
    img: '/services/devops_service/perldance.webp',
    width: 87,
    height: 61
  }
];

export const dbs = [
  {
    img: '/services/devops_service/mongodb.webp',
    width: 136,
    height: 65
  },
  {
    img: '/services/devops_service/mysql.webp',
    width: 84,
    height: 58
  },
  {
    img: '/services/devops_service/postgre.webp',
    width: 146,
    height: 54
  },
  {
    img: '/services/devops_service/mariadb.webp',
    width: 84,
    height: 62
  },
  {
    img: '/services/devops_service/apache.webp',
    width: 133,
    height: 51
  },
  {
    img: '/services/devops_service/nginx.webp',
    width: 138,
    height: 51
  },
  {
    img: '/services/devops_service/wildfly.webp',
    width: 79,
    height: 59
  },
  {
    img: '/services/devops_service/redis.webp',
    width: 138,
    height: 46
  }
];
